<div [formGroup]="form">
  <div class="table-responsive no-min-height">
    <table
      class="table table_middle table-striped"
      [formArrayName]="field_name">
      <tr>
        <th>Основное</th>
        <th>Станция</th>
        <th>До метро, метров</th>
        <th>Транспортом, мин</th>
        <th>Пешком, мин</th>
        <th></th>
      </tr>
      @for (el of subways.controls; track el; let i = $index) {
        <tr
          [formGroupName]="i">
          <td>
            <app-material-input-checkbox
              [disabled]="subways.controls[i].get('is_main').value || !isEdit"
              formControlName="is_main">
            </app-material-input-checkbox>
          </td>
          <td style="min-width: 15rem;">
            @if (subway_list && subway_list.length && isEdit) {
              <app-material-select2
                formControlName="id">
                <option [value]="''">Не выбрано</option>
                @for (el of subway_list | exclude: chosen_elements:el.get('id').value; track el) {
                  <option
                    [value]="el['dict_subway_id']">
                    #{{el['dict_subway_id']}} {{el['dict_subway_caption']}}
                    @if (el['dict_subway_is_map']) { (есть на карте) } @else { (нет на карте) }
                  </option>
                }
              </app-material-select2>
            }
            @if (subway_list && subway_list.length && !isEdit) {
              @let currentId = subways.controls[i].get('id').value;
              @if (currentId) {
                <p>
                  @for (item of subway_list; track item.dict_highway_id) {
                    @if (item['dict_subway_id'] === +currentId) {
                      #{{item['dict_subway_id']}} {{item['dict_subway_caption']}}
                      @if (item['dict_subway_is_map']) { (есть на карте) } @else { (нет на карте) }
                    }
                  }
                </p>
              } @else {
                <p>Не выбрано</p>
              }
            }
          </td>
          <td>
            @if (isEdit) {
              <app-material-input
                formControlName="distance">
              </app-material-input>
            }
            @if (!isEdit) {
              @let dist = subways.controls[i].get('distance')?.value;
              <p>{{ dist || '—' }}</p>
            }
          </td>
          <td>
            @if (isEdit) {
              <app-material-input
                formControlName="distance_min_transport">
              </app-material-input>
            }
            @if (!isEdit) {
              @let dist_tr = subways.controls[i].get('distance_min_transport')?.value;
              <p>{{ dist_tr || '—' }}</p>
            }
          </td>
          <td>
            @if (isEdit) {
              <app-material-input
                formControlName="distance_min_walk">
              </app-material-input>
            }
            @if (!isEdit) {
              @let dist_w = subways.controls[i].get('distance_min_walk')?.value;
              <p>{{ dist_w || '—' }}</p>
            }
          </td>
          <td>
            @if (isEdit) {
              <a
                (click)="dropSubway(i)"
                class="button button_icon ng-star-inserted"
                href="javascript:void(0)"
                title="Информация">
                <i class="fa fa-fw fa-trash"></i>
              </a>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>
@if (isEdit) {
  <span class="button mt-3" (click)="addSubway()">Добавить</span>
}
